import { Money } from './money';

export const MIN_STAKE = '2.00';
// Storage range, not a product-level stake cap. Balances use the same bound.
export const MAX_POINTS = '9223372036854775807';
export function parseStake(value: unknown, minimum = MIN_STAKE): string | null {
  if (
    typeof value !== 'string' ||
    !/^(?:0|[1-9]\d{0,18})(?:\.\d{1,2})?$/.test(value)
  )
    return null;
  const amount = new Money(value);
  return amount.gte(minimum) && amount.lte(MAX_POINTS)
    ? amount.toFixed(2)
    : null;
}
export function clampStake(value: string, balance: string | null): string {
  if (balance === null) return value;
  const funds = new Money(balance);
  if (funds.lt(MIN_STAKE)) return funds.toFixed(2, Money.ROUND_DOWN);
  const amount = /^(?:0|[1-9]\d{0,18})(?:\.\d{0,2})?$/.test(value)
    ? value
    : null;
  return Money.min(funds, Money.max(MIN_STAKE, amount ?? MIN_STAKE)).toFixed(
    2,
    Money.ROUND_DOWN,
  );
}
